export const INITIAL_RESULT_SIZE = 30
export const DEFAULT_PAGE_SIDEBAR_WIDTH = 191
